// extracted by mini-css-extract-plugin
export default {"caution_300":"#ffc37d","tabFocusedBorder":"style_tabFocusedBorder__1z8hq","mouseFocusedBorder":"style_mouseFocusedBorder__espQW"};